(function () {
  function moveGorgiasBeforeReactAttaches() {
    var targetLocation = document.querySelector('.header__column.header__column--center');

    if (!targetLocation) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (
            node.nodeType === 1 &&
            (node.id === 'gorgias-chat-container' || node.getAttribute('data-gorgias-chat-app'))
          ) {
            targetLocation.insertAdjacentElement('afterend', node);
            observer.disconnect();
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function addOutlineForChatButton() {
    var intervalId = setInterval(function () {
      var iframe = document.querySelector('iframe#chat-button');
      if (!iframe) return;

      var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      if (!iframeDoc) return;

      var chatButton = iframeDoc.querySelector('#gorgias-chat-messenger-button');
      if (!chatButton) return;

      var style = iframeDoc.createElement('style');
      style.textContent =
        '#gorgias-chat-messenger-button:focus-visible { outline: 2px solid red; outline-offset: 1px; }';
      iframeDoc.head.appendChild(style);

      clearInterval(intervalId);
    }, 300);

    setTimeout(function () {
      clearInterval(intervalId);
    }, 10000);
  }

  function removeTabIndexFromChatCampaigns() {
    var intervalId = setInterval(function () {
      var chatCampaigns = document.querySelector('#chat-campaigns');
      if (chatCampaigns) {
        chatCampaigns.setAttribute('tabindex', '-1');
        clearInterval(intervalId);
      }
    }, 300);

    setTimeout(function () {
      clearInterval(intervalId);
    }, 10000);
  }

  moveGorgiasBeforeReactAttaches();
  addOutlineForChatButton();
  removeTabIndexFromChatCampaigns();
})();
